export default __webpack_public_path__ + "static/ProximaNova-Semibold-d08b0ad411d5bc9c3cf950789aa1558a.woff2";